import React, { useRef, useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Modal from "react-modal";
import { toast } from "react-toastify";
import Select from "react-select";
import moment from "moment";

const FarmerInputTemplateForm = (props) => {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      overflow: "hidden",
      width: "140px",
      height: "20p",
      margin: "3px",
    }),
    dropdownContainer: (base, state) => ({
      ...base,
      gridTemplateRows: "0 min-content",
    }),
  };
  const frmRef = useRef({});
  const [employeeData, setEmployeeData] = useState([]);
  const [employeeId, setEmployeeId] = useState();
  const [unitsData, setUnitsData] = useState();
  const [itemSubType, setItemSubType] = useState();
  const [products, setProducts] = useState();
  const [seasonlist, setSeasonlist] = useState(null);

  const [seasonId, setSeasonId] = useState();

  const [selectedSubType, setSelectedSubType] = useState();
  const [selectedUnit, setSelectedUnit] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState();
  const [selectionSubType, setSelectionSubType] = useState([]);
  const [selectionProduct, setSelectionProduct] = useState([]);
  const [selectionUnit, setSelectionUnit] = useState([]);
  const [filterProducts, setFilterProducts] = useState();
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const [cropId, setCropId] = useState([]);
  const [unitId, setUnitId] = useState([]);
  const [cropList, setCropList] = useState([]);
  const [unitList, setUnitList] = useState([]);

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  const productRef = useRef({});

  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px", // Adjust the width as needed
      height: "80%",
      minHeight: "500px",
      overflow: "auto",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const { sendRequest: getcrop } = useHttp();
  const fillCrop = () => {
    getcrop(
      {
        url: "/api/crops/",
      },
      (res) => {
        if (res) {
          setCropList(res);
        }
      }
    );
  };

  useEffect(() => {
    fillCrop();
  }, [getcrop]);

  const { sendRequest: getSeason } = useHttp();
  useEffect(() => {
    getSeason(
      {
        url: `/api/seasons/?orgId=${localStorage.getItem(
          "orgId"
        )}&&createdBy=${localStorage.getItem("id")}`,
      },
      (data) => {
        setSeasonlist(data);
      }
    );
  }, [getSeason]);

  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employeeByUsecase/?orgId=${localStorage.getItem(
          "orgId"
        )}&useCase=Procurement`,
      },
      (data) => {
        //console.log(data);
        var emplist = data.output;

        setEmployeeData(emplist);
      }
    );
  }, []);

  const { sendRequest: getunits } = useHttp();

  useEffect(() => {
    getunits(
      {
        url: `/api/units?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          console.log("res", res);
          const areaUnits = res.filter((unit) => unit.unitTypeName == "Area");
          setUnitsData(res);
          setUnitList(areaUnits);
        }
      }
    );
  }, [getunits]);

  const { sendRequest: getSubItem } = useHttp();

  useEffect(() => {
    getSubItem(
      {
        url: `/api/productsubitem/?orgId=${localStorage.getItem(
          "orgId"
        )}&&createdBy=${localStorage.getItem("id")}`,
      },
      (res) => {
        if (res) {
          setItemSubType(res);
        }
      }
    );
  }, [getSubItem]);

  useEffect(() => {
    setSelectionSubType(
      itemSubType &&
        itemSubType.map((x) => ({
          value: x.productSubTypeId,
          label: x.productTypeName + " " + x.productSubTypeName,
        }))
    );
  }, [itemSubType]);

  const { sendRequest: getProducts } = useHttp();

  useEffect(() => {
    getProducts(
      {
        url: `/api/product/?orgId=${localStorage.getItem(
          "orgId"
        )}&&createdBy=${localStorage.getItem("id")}`,
      },
      (res) => {
        if (res) {
          setProducts(res);
        }
      }
    );
  }, [getProducts]);

  const handleSubTypeChange = (option) => {
    setSelectedSubType(option);
    setSelectedProduct([]);
    setSelectedUnit([]);
  };

  useEffect(
    (e) => {
      const filteredProData =
        products &&
        products.filter(
          (item) =>
            parseInt(item.productSubTypeId) ===
            parseInt(selectedSubType && selectedSubType.value)
        );

      setFilterProducts(filteredProData);

      setSelectionProduct(
        filteredProData &&
          filteredProData.map((x) => ({
            value: x.productId,
            label: x.productName,
          }))
      );
    },
    [selectedSubType]
  );

  const handleProdcutChange = (option) => {
    if (option) {
      setSelectedProduct(option);
      setSelectedUnit([]);
    }
  };

  useEffect(
    (e) => {
      if (selectedProduct) {
        const filteredUnitId =
          filterProducts &&
          filterProducts
            .filter(
              (item) =>
                parseInt(item.productId) ===
                parseInt(selectedProduct && selectedProduct.value)
            )
            .map((item) => item);

        if (selectedProduct.value) {
          const id = filteredUnitId && filteredUnitId[0].unitId; //unit id

          const filteredUnits =
            unitsData &&
            unitsData
              .filter(
                (item) => parseInt(item.unitId) === parseInt(id) //filter unit type id
              )
              .map((item) => item.unitTypeId);

          const TypeId = (filteredUnits && filteredUnits[0]) || 0;

          const uData =
            unitsData &&
            unitsData.filter(
              (item) => parseInt(item.unitTypeId) === parseInt(TypeId) //filter all units
            );

          // set unit data

          setSelectionUnit(
            uData &&
              uData.map((x) => ({
                value: x.unitId,
                label: x.unitName,
              }))
          );
        }
      }
    },
    [selectedProduct]
  );
  const handleUnitChange = (option) => {
    setSelectedUnit(option);
  };

  const [productUsedFor, setProductUsedFor] = useState("Nursery Inputs");

  const submitProduct = (e) => {
    e.preventDefault();
    const productName = selectedProduct && selectedProduct.label;

    const itemSubTypeName = selectedSubType && selectedSubType.label;
    const quantity = productRef.current.quantity.value;

    const unit = selectedUnit && selectedUnit.label;

    if (!productName || !itemSubTypeName || !quantity || !unit) {
      toast.success("Please fill in all fields!");

      return;
    } else {
      const productName = selectedProduct && selectedProduct.label;
      const isDuplicate = productDetails.some(
        (product) =>
          product.productName === productName &&
          product.productUsedfor === productUsedFor
      );
      if (isDuplicate) {
        toast.success("Item already exists!");

        return;
      }
      setProductDetails((x) => [
        ...x,
        {
          productRequestDetailId: generateUniqueID(),
          productUsedfor: productUsedFor,
          productId: selectedProduct && selectedProduct.value,
          productName: selectedProduct && selectedProduct.label,

          productSubTypeName: selectedSubType && selectedSubType.label,
          productSubTypeId: selectedSubType && selectedSubType.value,
          quantity: productRef.current.quantity.value || 0,
          quantityBalance: productRef.current.quantity.value || 0,

          unitId: selectedUnit && selectedUnit.value,
          unitName: selectedUnit && selectedUnit.label,
        },
      ]);

      setSelectedUnit({});
      setSelectedProduct({});
      setSelectedSubType({});
      productRef.current.quantity.value = 0;
    }
  };

  const handleDelete = (index, e) => {
    setProductDetails(productDetails.filter((v, i) => i !== index));
  };

  function generateUniqueID() {
    const currentDateTime = new Date();
    const uniqueID =
      currentDateTime.getTime() + Math.floor(Math.random() * 1000);
    //console.log(uniqueID);
    return uniqueID.toString();
  }

  const { sendRequest: postProductRequest } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    const data = {
      templateDate: moment(frmRef.current.templateDate.value).format(
        "DD/MM/YYYY"
      ),
      templateName: frmRef.current.templateName.value,
      fieldExecutiveId: employeeId,
      cropId: cropId,
      templateAreaUnitId: unitId,
      seasonId: seasonId,

      templateArea: frmRef.current.templateArea.value,
      description: frmRef.current.description.value,
      farmerInputTempDetails: productDetails,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: parseInt(localStorage.getItem("orgId")),
    };

    if (props.update) {
      data["farmerInputTemplateId"] = props.update.farmerInputTemplateId;
    }

    console.log(data);

    postProductRequest(
      {
        url: "/api/farmerTemplate/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        //console.log(data);

        toast.success(
          `Farmer Input Template ${props.update ? "Updated" : "Added"}`
        );
        props.addForm(false);
      }
    );
  };

  const { sendRequest: getProductsForUpdate } = useHttp();

  useEffect(() => {
    if (props.update) {
      // console.log(props.update);

      frmRef.current.templateDate.value = moment(
        props.update.templateDate,
        "DD/MM/YYYY"
      ).format("YYYY-MM-DD");
      frmRef.current.templateName.value = props.update.templateName;
      setEmployeeId(props.update.fieldExecutiveId);
      setSeasonId(props.update.seasonId);
      setCropId(props.update.cropId);
      setUnitId(props.update.unitId);

      const Id = props.update.farmerInputTemplateId || 0;
      if (Id) {
        getProductsForUpdate(
          {
            url: `/api/farmerTemplate/?farmerInputTemplateId=${Id}&orgId=${localStorage.getItem(
              "orgId"
            )}`,
          },
          (data) => {
            console.log(data);

            let ProData = data.farmerInputTempDetails;

            setProductDetails(
              ProData &&
                ProData.map((detail) => ({
                  farmerInputTemplateDetailId:
                    detail.farmerInputTemplateDetailId,
                  productUsedfor: detail.productUsedfor,
                  productId: detail.productId,
                  productName: detail.productName,
                  productSubTypeName: detail.productSubTypeName,
                  productSubTypeId: detail.productSubType,
                  quantity: detail.quantity,
                  quantityBalance: detail.quantity,
                  unitId: detail.unitId,
                  unitName: detail.unitAbbreviation,
                }))
            );
          }
        );
      }

      frmRef.current.templateArea.value = props.update.templateArea;
      frmRef.current.description.value = props.update.description;
    }
  }, [props.update]);

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Farmer Input Template Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"date"}>{"Template Date"}</label>
                      <input
                        type={"date"}
                        id={"templateDate"}
                        required
                        ref={(el) => (frmRef.current["templateDate"] = el)}
                        className="form-control"
                        min={props.update ?? currentDate}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"date"}>{"Template Name"}</label>

                      <input
                        id="templateName"
                        name="templateName"
                        ref={(el) => (frmRef.current["templateName"] = el)}
                        className="form-control"
                        required
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"executive_name"}>
                        {"Field Executive"}
                      </label>
                      <select
                        id="emp_id"
                        className="form-control"
                        ref={(el) => (frmRef.current["emp_id"] = el)}
                        value={employeeId}
                        required
                        onChange={(e) => {
                          setEmployeeId(e.target.value);
                        }}
                      >
                        <option>Select</option>
                        {employeeData &&
                          employeeData.map((x) => (
                            <option key={x.userId} value={x.empId}>
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"crop"}>{"Crop"}</label>
                      <select
                        id="cropName"
                        className="form-control"
                        ref={(el) => (frmRef.current["cropName"] = el)}
                        value={cropId}
                        required
                        onChange={(e) => {
                          setCropId(e.target.value);
                        }}
                      >
                        <option>Select</option>
                        {cropList &&
                          cropList.map((x) => (
                            <option key={x.cropId} value={x.cropId}>
                              {x.cropName}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"product_details"}>
                        {"Product Details"}
                      </label>
                      <br /> &nbsp; &nbsp; &nbsp; &nbsp;
                      <button
                        type="button"
                        id={"product_details"}
                        onClick={() => setIsModalOpen(true)}
                        ref={(el) => (frmRef.current["product_details"] = el)}
                        className="btn btn-sm btn-success"
                      >
                        Add
                      </button>
                    </div>

                    <div className="col-md-3">
                      <label>Template Area</label>
                      <input
                        type={"Number"}
                        id={"templateArea"}
                        required
                        ref={(el) => (frmRef.current["templateArea"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-3">
                      <label>Unit</label>
                      <select
                        id="unitName"
                        className="form-control"
                        ref={(el) => (frmRef.current["unitName"] = el)}
                        value={unitId}
                        required
                        onChange={(e) => {
                          setUnitId(e.target.value);
                        }}
                      >
                        <option>Select</option>
                        {unitList &&
                          unitList.map((x) => (
                            <option key={x.unitId} value={x.unitId}>
                              {x.unitName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        {" "}
                        <label>Season</label>
                        <select
                          className="form-control"
                          required
                          value={seasonId}
                          onChange={(e) => {
                            setSeasonId(e.target.value);
                          }}
                        >
                          <option value="">Select</option>
                          {seasonlist &&
                            seasonlist.map((x) => (
                              <option key={x.seasonId} value={x.seasonId}>
                                {x.seasonName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"description"}>{"Description"}</label>
                      <input
                        type={"text"}
                        id={"description"}
                        required
                        ref={(el) => (frmRef.current["description"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className=" text-right">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>

      {isModalOpen && (
        <Modal isOpen={isModalOpen} style={customModalStyles}>
          <div className="">
            <h3 className="card-title">Product Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 mt-2">
              <div>
                <label htmlFor={"itemType"}>
                  Product Used For : &nbsp;&nbsp;
                </label>
                <label>
                  <input
                    type="radio"
                    name="productUsedFor"
                    value="Nursery Inputs"
                    onChange={(e) => setProductUsedFor(e.target.value)}
                    checked={productUsedFor === "Nursery Inputs"}
                  />
                  &nbsp; Nursery Inputs
                </label>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <label>
                  <input
                    type="radio"
                    name="ProductUsedFor"
                    value="Field Inputs"
                    onChange={(e) => setProductUsedFor(e.target.value)}
                    checked={productUsedFor === "Field Inputs"}
                  />
                  &nbsp; Field Inputs
                </label>
              </div>
            </div>
          </div>

          <div className="row mt-2">
            <div className="col-md-3">
              <label htmlFor={"itemType"}>Product Sub Type</label>

              <Select
                styles={customStyles}
                options={selectionSubType}
                value={selectedSubType}
                onChange={(option) => {
                  handleSubTypeChange(option);
                }}
                required
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"itemCategory"}>Product Name</label>

              <Select
                styles={customStyles}
                options={selectionProduct}
                value={selectedProduct}
                onChange={(option) => {
                  handleProdcutChange(option);
                }}
                required
              />
            </div>

            <div className="col-md-2">
              <label htmlFor={"itemDescription"}>Quantity</label>&nbsp;
              <input
                type={"number"}
                id={"quantity"}
                required
                ref={(el) => (productRef.current["quantity"] = el)}
                className="form-control"
              />
            </div>

            <div className="col-md-3">
              <label htmlFor={"itemUnitPrice"}>Unit</label>
              <Select
                styles={customStyles}
                options={selectionUnit}
                value={selectedUnit}
                onChange={(option) => {
                  handleUnitChange(option);
                }}
                required
              />
            </div>

            <div className="col-md-1">
              <br />
              &nbsp;
              <button className="btn btn-success" onClick={submitProduct}>
                +
              </button>
            </div>
          </div>

          <hr />
          <div className="row">
            <table className="table table-bordered table-responsivetext-center">
              <thead className="">
                <tr className="">
                  <th>Sr. No</th>
                  <th>Product Sub Type</th>
                  <th>Product Used For</th>
                  <th>Product Name</th>
                  <th>Quantity</th>
                  <th>Unit</th>

                  <th>Delete</th>
                </tr>
              </thead>

              <tbody>
                {productDetails &&
                  productDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{itm.productSubTypeName}</td>
                        <td>{itm.productUsedfor}</td>

                        <td>{itm.productName}</td>
                        <td>{itm.quantity}</td>
                        <td>{itm.unitName}</td>

                        <td>
                          <button
                            className="btn"
                            onClick={(e) => handleDelete(i, e)}
                          >
                            <i className="fas fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
          <hr />

          <div className="text-center">
            <button
              className="btn btn-sm btn-primary"
              onClick={() => {
                productDetails &&
                  productDetails.map((x) => (x["isSave"] = true));
                setIsModalOpen(false);
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}
    </>
  );
};

export default FarmerInputTemplateForm;
